"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BigNumber = exports.toTokenHex = exports.toFixed = exports.abs = exports.sqrt = exports.pow = exports.minus = exports.plus = exports.multipliedBy = exports.dividedBy = exports.tickRound = exports.ceil = exports.floor = exports.round = void 0;
const bignumber_js_1 = __importDefault(require("bignumber.js"));
exports.BigNumber = bignumber_js_1.default;
const round = (value, decimals = 0) => new bignumber_js_1.default(value).decimalPlaces(decimals).toNumber();
exports.round = round;
const floor = (value, decimals = 0) => new bignumber_js_1.default(value).decimalPlaces(decimals, bignumber_js_1.default.ROUND_FLOOR).toNumber();
exports.floor = floor;
const ceil = (value, decimals = 0) => new bignumber_js_1.default(value).decimalPlaces(decimals, bignumber_js_1.default.ROUND_CEIL).toNumber();
exports.ceil = ceil;
const tickRound = (value, step) => new bignumber_js_1.default(value).dividedBy(step).decimalPlaces(0, bignumber_js_1.default.ROUND_HALF_EVEN).multipliedBy(step).toNumber();
exports.tickRound = tickRound;
const dividedBy = (value1, value2) => new bignumber_js_1.default(value1).dividedBy(value2).toNumber();
exports.dividedBy = dividedBy;
const multipliedBy = (value1, value2) => new bignumber_js_1.default(value1).multipliedBy(value2).toNumber();
exports.multipliedBy = multipliedBy;
const plus = (value1, value2) => new bignumber_js_1.default(value1).plus(value2).toNumber();
exports.plus = plus;
const minus = (value1, value2) => new bignumber_js_1.default(value1).minus(value2).toNumber();
exports.minus = minus;
const pow = (value1, value2) => new bignumber_js_1.default(value1).pow(value2).toNumber();
exports.pow = pow;
const sqrt = (value1) => new bignumber_js_1.default(value1).sqrt().toNumber();
exports.sqrt = sqrt;
const abs = (value1) => new bignumber_js_1.default(value1).abs().toNumber();
exports.abs = abs;
const toFixed = (value, decimals = 0) => new bignumber_js_1.default(value).toFixed(decimals);
exports.toFixed = toFixed;
const toTokenHex = (value, decimals = 0) => new bignumber_js_1.default(value).multipliedBy(Math.pow(10, decimals)).toString(16);
exports.toTokenHex = toTokenHex;
//# sourceMappingURL=math.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/libs-tools/functions/math.js
// module id = 489
// module chunks = 0